import { Component, Input, inject } from '@angular/core';
import { SummaryCardAction, SummaryCardComponent } from '@next/core-lib/components';
import { DialogService } from '@next/core-lib/dialog';
import { LocaleService, TranslatePipe } from '@next/core-lib/i18n';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-water-authority-exceedance-widget',
    templateUrl: './water-authority-exceedance-widget.component.html',
    styleUrls: ['./water-authority-exceedance-widget.component.scss'],
    imports: [
        SummaryCardComponent,
        MatProgressSpinner,
        TranslatePipe,
    ],
})
export class WaterAuthorityExceedanceWidgetComponent {
    private readonly locale = inject(LocaleService);
    private readonly dialog = inject(DialogService);

    @Input() waterAuthorities: { title: string; exceedances: { substance: string; example: string }[] }[] = [];
    @Input() loading = false;

    cardActions: SummaryCardAction[] = [
        {
            id: 'info',
            icon: 'info_outline',
            callback: () => this.openInformationDialog(),
        },
    ];

    openInformationDialog(): void {
        this.dialog.notify(
            {
                title: this.locale.translate('TGA.WaterAuthorityExceedancesInfoTitle'),
                text: this.locale.translate('TGA.WaterAuthorityExceedancesInfoText'),
            },
            {
                maxWidth: '600px',
            },
        );
    }
}
